/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAllowedOriginsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListAllowedOriginsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListAllowedOriginsSecurity = {
  option1?: ListAllowedOriginsSecurityOption1 | undefined;
  option2?: ListAllowedOriginsSecurityOption2 | undefined;
};

export type ListAllowedOriginsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListAllowedOriginsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListAllowedOriginsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListAllowedOriginsSecurityOption1$Outbound,
  ListAllowedOriginsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listAllowedOriginsSecurityOption1ToJSON(
  listAllowedOriginsSecurityOption1: ListAllowedOriginsSecurityOption1,
): string {
  return JSON.stringify(
    ListAllowedOriginsSecurityOption1$outboundSchema.parse(
      listAllowedOriginsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListAllowedOriginsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListAllowedOriginsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListAllowedOriginsSecurityOption2$Outbound,
  ListAllowedOriginsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAllowedOriginsSecurityOption2ToJSON(
  listAllowedOriginsSecurityOption2: ListAllowedOriginsSecurityOption2,
): string {
  return JSON.stringify(
    ListAllowedOriginsSecurityOption2$outboundSchema.parse(
      listAllowedOriginsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListAllowedOriginsSecurity$Outbound = {
  Option1?: ListAllowedOriginsSecurityOption1$Outbound | undefined;
  Option2?: ListAllowedOriginsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListAllowedOriginsSecurity$outboundSchema: z.ZodMiniType<
  ListAllowedOriginsSecurity$Outbound,
  ListAllowedOriginsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListAllowedOriginsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListAllowedOriginsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listAllowedOriginsSecurityToJSON(
  listAllowedOriginsSecurity: ListAllowedOriginsSecurity,
): string {
  return JSON.stringify(
    ListAllowedOriginsSecurity$outboundSchema.parse(listAllowedOriginsSecurity),
  );
}

/** @internal */
export type ListAllowedOriginsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListAllowedOriginsRequest$outboundSchema: z.ZodMiniType<
  ListAllowedOriginsRequest$Outbound,
  ListAllowedOriginsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listAllowedOriginsRequestToJSON(
  listAllowedOriginsRequest: ListAllowedOriginsRequest,
): string {
  return JSON.stringify(
    ListAllowedOriginsRequest$outboundSchema.parse(listAllowedOriginsRequest),
  );
}
